export default function cardWidget() {
  const widgetName = 'themeBackground';
  const widgetOpts = themeBackgroundOpts;
  const $widgetElement = $(`#${widgetName}`);
  const mainFeatureElement = 'body';

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,

    cardWidgetLoaded: function (data, _owl, hasData) {
      $(`${mainFeatureElement}`).prepend('<div class="managed-bg"></div>');
      if (hasData) {
        addMainFeatureBackground(data.items[0], mainFeatureElement);
      }
      $widgetElement.remove();
      $(`${mainFeatureElement} .managed-bg`).addClass('show-bg');
    },
  });
}

function addMainFeatureBackground(widgetData, featureTarget) {
  const { ImageWithPath } = widgetData;

  $(`${featureTarget} .managed-bg`).css({
    background: `url('${ImageWithPath}') no-repeat center/cover fixed`,
  });
}
